var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-wrapper"},[_c('DownloadSideBar'),_c('div',{staticClass:"content-wrapper"},[_c('DownloadCrumbLinks'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }